var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step3"},[_c('contact-person-form-wrapper'),_c('invoice-form'),_c('bank-number-from-wrapper'),_c('invoice-additional-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }